import React from "react";
import { BrowserRouter } from "react-router-dom";
import Layout from "./layouts/layout";
import ReactGA from "react-ga";
import { ConfigProvider } from "antd";
import "./assets/css/stylenew.scss";
import "./assets/css/stylenewupdated.scss";
import "./assets/css/stylenewDesign.scss";

const AppContainer = () => {
  ReactGA.initialize("G-VXJ4GHSTJG");
  return (
    <>
      <BrowserRouter>
       <ConfigProvider
        getPopupContainer={(triggerNode) => {
          return (triggerNode && triggerNode?.parentElement) || document.body;
        }}
      >
          <Layout />
        </ConfigProvider>
      </BrowserRouter>
    </>
  );
};

export default AppContainer;
